import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { appendTaskLogs, createTask, getTask, queryTasks, updateTask } from '@wix/ambassador-individual-scheduling-assistant-v1-task/http';
import { HttpBaseClient } from '../BaseClient/HttpBaseClient';
import { IndividualTaskClientBase } from './IndividualTaskClientBase';
export class IndividualTaskClient extends HttpBaseClient(IndividualTaskClientBase) {
  constructor() {
    super(...arguments);
    _defineProperty(this, "getTaskImpl", getTask);
    _defineProperty(this, "queryTasksImpl", queryTasks);
    _defineProperty(this, "createTaskImpl", createTask);
    _defineProperty(this, "updateTaskImpl", updateTask);
    _defineProperty(this, "appendTaskLogsImpl", appendTaskLogs);
  }
}
//# sourceMappingURL=IndividualTaskClientHttp.js.map